import { render, staticRenderFns } from "./data-view-canvas.vue?vue&type=template&id=1c7cf780&scoped=true&"
import script from "./data-view-canvas.vue?vue&type=script&lang=js&"
export * from "./data-view-canvas.vue?vue&type=script&lang=js&"
import style0 from "./data-view-canvas.vue?vue&type=style&index=0&id=1c7cf780&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7cf780",
  null
  
)

export default component.exports